export default __webpack_public_path__ + "static/media/smBannerDaCrazyLightMode.38241a02.png";